import { HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/events.service";
export class LoaderInterceptor {
    constructor(events) {
        this.events = events;
    }
    intercept(req, next) {
        this.events.broadcast('loader', true);
        return next.handle(req).pipe(tap((event) => {
            if (event instanceof HttpResponse) {
                this.events.broadcast('loader', false);
                this.events.broadcast('btnpreloader');
            }
        }, (err) => {
            this.events.broadcast('loader', false);
            this.events.broadcast('btnpreloader');
        }));
    }
}
LoaderInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoaderInterceptor_Factory() { return new LoaderInterceptor(i0.ɵɵinject(i1.Events)); }, token: LoaderInterceptor, providedIn: "root" });
